import React from "react";
import {observer} from "mobx-react-lite";
import Select from "react-select";

const DimensionSelect = observer(({dimensionSelectStore, disabled = false, multi = false}) => {
  return (
    <Select
      sm={10}
      className="react-select-container"
      classNamePrefix="react-select"
      value={dimensionSelectStore?.selectedDimension ? dimensionSelectStore.selectedDimension : dimensionSelectStore?.selectedDimensions}
      options={dimensionSelectStore?.dimensionOptionValues()}
      isSearchable
      onChange={(data) => dimensionSelectStore?.setSelectedDimension(data)}
      getOptionLabel={option => option.label}
      getOptionValue={option => option.uuid}
      placeholder="Select"
      isDisabled={disabled}
      isMulti = {multi}
    />

  );
});

export default DimensionSelect;
